import { toggle } from "@otto-ec/global-resources/toggle";
import { createExpiryScheduler, type ExpiryScheduler } from "utils/expiry";

/**
 *
 */
export function buildFetchHeaders(xFeature: string | null, xTeam: string | null): HeadersInit {
	return {
		Accept: "text/html;charset=UTF-8",
		"X-Requested-With": "XMLHttpRequest",
		"X-feature": xFeature ?? "unset",
		"X-team": xTeam ?? "unset",
	};
}

/**
 *
 *
 */
export function buildSearchParams(params: Record<string, string | null | undefined>): URLSearchParams {
	return Object.entries(params).reduce((urlSearchParams, [key, value]) => {
		if (value) {
			urlSearchParams.append(key, value);
		}
		return urlSearchParams;
	}, new URLSearchParams());
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export abstract class BenefitElement extends HTMLElement {
	/**
 *
 *
 */
	expiry: ExpiryScheduler = createExpiryScheduler();

	/**
 *
 *
 */
	private initialized = false;

	/**
 *
 *
 */
	connectedCallback(): void {
		if (this.initialized) {
			return;
		}
		this.initialized = true;
		void (async () => {
			await this.onInit?.();
			await this.hydrate();
		})();
	}

	/**
 *
 */
	disconnectedCallback(): void {
		this.expiry.cleanup();
	}

	/**
 *
 *
 */
	protected abstract hydrate(): Promise<void>;

	/**
 *
 *
 *
 *
 */
	protected onInit?(): Promise<void>;

	/**
 *
 *
 *
 *
 */
	async triggerReload(): Promise<void> {
		await this.hydrate();
	}

	/**
 *
 *
 *
 *
 *
 */
	protected triggerReloadAt(expirationDate: string): void {
		this.expiry.scheduler(expirationDate, () => void this.hydrate());
	}
}

/**
 *
 *
 */
export function defineElement(elementClass: CustomElementConstructor, name: string, toggleKey: string): void {
	if (customElements && customElements.get(name) === undefined && !toggle.get(toggleKey, false)) {
		customElements.define(name, elementClass);
	}
}
